export enum DragTypes {
  ReorderProgramItem = 'reorderProgramItem',
  ExerciseGroupReorder = 'exerciseGroupReorder',
  GroupSetReorder = 'groupSetReorder',
  DragExercise = 'dragExercise',
  // ExerciseGroupMerge = 'exerciseGroupMerge',
  // ExerciseReorder = 'exerciseReorder', // should be added for workout exercise reordering?
}
